import {isNotNil} from 'ramda';

import {getAllFeatureFlags} from './getAllFeatureFlags';

let isDev = false;
try {
  isDev = process.env.ENV_TYPE === 'dev';
} catch {}

export const isFeatureEnabled = (featureName: string) => {
  const flags = getAllFeatureFlags();

  const mockedFlags = localStorage.getItem('featureFlagMock');
  const isDevSettingsMockingFlagsmithFlags = isDev && isNotNil(mockedFlags);

  if (!flags) {
    return false;
  }

  if (isDevSettingsMockingFlagsmithFlags) {
    try {
      const parsedMockedFlags = JSON.parse(mockedFlags) as Record<string, {enabled: boolean}>;
      return parsedMockedFlags?.[featureName]?.enabled ?? flags?.[featureName]?.enabled ?? false;
    } catch (error) {
      console.warn('Error parsing mocked flags', error);
      return flags?.[featureName]?.enabled ?? false;
    }
  }

  return flags?.[featureName]?.enabled ?? false;
};
